import { get } from 'lodash';
import {
  CLEAR_ADDITIONAL_ACCOMMODATIONS,
  FETCH_ADDITIONAL_ACCOMMODATIONS,
  UPDATE_FILTERED_ACCOMMODATIONS_RESULTS,
} from 'Store/booking/additional-accommodations/additionalAccommodations.action';
import { filterDataSet } from 'Store/filters/filtersHelper';
type State = Array<any> | null | undefined;
const initialState: State = null;

function filteredAccommodationsReducer(
  state: State = initialState,
  action: Action<any> | null | undefined,
): State {
  const additionalAccommodations = get(action, 'payload.additionalAccommodations') || [];
  const filters = get(action, 'payload.filters') || [];

  switch (get(action, 'type')) {
    case CLEAR_ADDITIONAL_ACCOMMODATIONS:
    case FETCH_ADDITIONAL_ACCOMMODATIONS:
      return initialState;

    case UPDATE_FILTERED_ACCOMMODATIONS_RESULTS:
      return filterDataSet(additionalAccommodations, filters);

    default:
      return state;
  }
}

export default filteredAccommodationsReducer;
